export const DEFAULT_CAMPAIGN_FEE = 20;

export const calculateCpiRate = (amount: number, appliedFee: number = DEFAULT_CAMPAIGN_FEE) => {
  return (amount - amount * (appliedFee / 100)).toFixed(2);
};
